import { Injectable } from '@angular/core';
import { ToastService } from 'ng-zorro-antd-mobile';

@Injectable({
  providedIn: 'root'
})
export class ZoToastService {

  constructor(private toastService: ToastService) {

  }

  showLoading(content: string = '加载中...'): void {
    setTimeout(() => {
      this.toastService.loading(content, 30000, () => {});
    }, 1);
  }

  hideLoading(): void {
    setTimeout(() => {
      this.toastService.hide();
    }, 1);
  }
}
